import React from "react";
import AuthProfile from "../components/AuthPages/AuthProfile";

export default function AuthProfilePage() {
  return <AuthProfile />;
}
